<template>
  <nav class="col-md-3 d-md-block sidebar-wrapper mb-4">
    <div class="sidebar-card">
      <b-navbar toggleable="md" class="p-0 flex-column align-items-stretch">

        <!-- Mobile Header & Toggle -->
        <div class="d-flex justify-content-between align-items-center w-100 d-md-none p-3 border-bottom">
          <h6 class="m-0 font-weight-bold text-dark"><i class="fa-solid fa-bars mr-2"></i> Μενού</h6>
          <b-navbar-toggle target="nav_collapse" class="border-0 bg-light"></b-navbar-toggle>
        </div>

        <b-collapse is-nav id="nav_collapse" class="w-100 flex-column align-items-stretch mt-3 mt-md-0 pb-3">

          <h6 class="sidebar-heading px-4 mt-4 mb-3 text-muted">
            <i class="fa-solid fa-newspaper mr-2"></i> Παλαιότερες Εκδόσεις
          </h6>

          <ul class="nav flex-column mb-3 sidebar-nav">
            <li class="nav-item">
              <router-link to="/1980" exact class="nav-link">
                <i class="fa-regular fa-calendar-days icon"></i> Δεκαετία 1980
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/1990" exact class="nav-link">
                <i class="fa-regular fa-calendar-days icon"></i> Δεκαετία 1990
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/2000" exact class="nav-link">
                <i class="fa-regular fa-calendar-days icon"></i> Δεκαετία 2000
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/2010" exact class="nav-link">
                <i class="fa-regular fa-calendar-days icon"></i> Δεκαετία 2010
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/2020" exact class="nav-link">
                <i class="fa-regular fa-calendar-days icon"></i> Δεκαετία 2020
              </router-link>
            </li>
          </ul>

          <h6 class="sidebar-heading px-4 mt-4 mb-3 text-muted border-top pt-4">
            <i class="fa-solid fa-book-open mr-2"></i> Ειδικές Εκδόσεις
          </h6>

          <ul class="nav flex-column mb-3 sidebar-nav">
            <li class="nav-item">
              <router-link to="/books" exact class="nav-link">
                <i class="fa-solid fa-book icon"></i> Κιμωλιακή Βιβλιοθήκη
              </router-link>
            </li>
          </ul>

        </b-collapse>
      </b-navbar>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-wrapper {
  padding-left: 15px;
  padding-right: 15px;
}

.sidebar-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 25px -5px rgba(2, 132, 199, 0.1), 0 8px 10px -6px rgba(2, 132, 199, 0.05);
  /* Blue tinted shadow */
  overflow: hidden;
  border-top: 5px solid #0284c7;
  /* Matching Greek blue top stripe */
}

.sidebar-heading {
  font-size: 0.75rem;
  font-weight: 700;
  color: #0284c7 !important;
  /* Vivid Aegean blue */
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.sidebar-nav {
  padding: 0 0.75rem;
}

.nav-item {
  margin-bottom: 0.25rem;
  width: 100%;
}

/* Override default bootstrap border rules if left behind */
li.nav-item {
  border: none !important;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  color: #0f172a !important;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.25s ease;
  text-decoration: none;
}

.nav-link .icon {
  margin-right: 12px;
  color: #7dd3fc;
  /* Very light sky blue default icon */
  font-size: 1.1rem;
  transition: color 0.25s ease;
  width: 20px;
  text-align: center;
}

.nav-link:hover {
  background-color: #f0f9ff !important;
  /* Soft distinct blue background on hover */
  color: #0369a1 !important;
  /* Deep blue text on hover */
  transform: translateX(4px);
}

.nav-link:hover .icon {
  color: #0284c7;
  /* Classic bright blue icon on hover */
}

/* Active Route Styling */
.router-link-active {
  background-color: #0284c7 !important;
  /* Solid Greek blue background */
  color: #ffffff !important;
  /* White text for high contrast */
  font-weight: 600;
  box-shadow: 0 4px 6px -1px rgba(2, 132, 199, 0.3);
}

.router-link-active .icon {
  color: #ffffff !important;
  /* White icon to match */
}
</style>



// WEBPACK FOOTER //
// src/components/sideMenu.vue